import { GoogleTagManagerAPI, type IGoogleTagManagerAPI } from 'services/google-tag-manager-api';

export function getGTMApi(): IGoogleTagManagerAPI {
  return GoogleTagManagerAPI.instance();
}
